<header [ngStyle]="{ background: router.url === '/' ? '#e7fafb' : '' }">
  <div class="logo-container">
    <img class="hamburger-menu" src="assets/menu.svg" (click)="showMenu = !showMenu" />
    <img class="logo" src="/assets/Ipam-logo.svg" routerLink="/" />
  </div>
  <nav>
    <div
      *ngFor="let item of menuItems"
      class="item"
      (click)="onMenuClick(item)"
      [ngStyle]="{
        color: item.submenu ? (router.url.includes(item.link) ? '#0f7e9a' : '#173b4d') : router.url === item.link ? '#0f7e9a' : '#173b4d'
      }"
    >
      {{ item.title }}
      <div class="submenu-container" *ngIf="item.submenu">
        <div class="item-submenu" *ngFor="let submenu of item.submenu" routerLink="{{ item.link + submenu.link }}">
          <span>{{ submenu.title }}</span>
        </div>
      </div>
    </div>
  </nav>
</header>
<div [hidden]="!showMenu" [ngClass]="{ 'mobile-menu': showMenu }">
  <nav #mobileMenu>
    <div class="close-icon">
      <img src="assets/close.svg" (click)="showMenu = false" height="20px" />
    </div>
    <div class="logo-container">
      <img class="logo" src="/assets/Ipam-logo.svg" (click)="onMenuClick({ title: 'خانه', link: '/' })" />
    </div>
    <div class="menu-item">
      <div
        *ngFor="let item of menuItems"
        class="item"
        (click)="onMenuClick(item)"
        [ngStyle]="{ color: router.url === item.link ? '#0f7e9a' : '#173b4d' }"
      >
        {{ item.title }}
        <div class="submenu-mobile" *ngIf="item.submenu && item.checked">
          <div class="item-submenu" *ngFor="let submenu of item.submenu">
            <span routerLink="{{ item.link + submenu.link }}" (click)="showMenu = false">{{ submenu.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
